import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Algo correu mal. Tente novamente.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const STATUS_OPTIONS = [
    { value: "a_aguardar", label: "A Aguardar" },
    { value: "pendente", label: "Recebido" },
    { value: "em_curso", label: "Em Curso" },
    { value: "concluido", label: "Concluído" },
    { value: "entregue", label: "Entregue" },
    { value: "cancelado", label: "Cancelado" },
];

export const STATUS_STYLES = {
    a_aguardar: "bg-orange-50 text-orange-800 border-orange-200",
    pendente: "bg-amber-100 text-amber-900 border-amber-200",
    em_curso: "bg-blue-100 text-blue-900 border-blue-200",
    concluido: "bg-green-100 text-green-900 border-green-200",
    entregue: "bg-zinc-100 text-zinc-700 border-zinc-200",
    cancelado: "bg-red-50 text-red-700 border-red-200",
};

export const STATUS_LABELS = {
    a_aguardar: "A Aguardar",
    pendente: "Recebido",
    em_curso: "Em Curso",
    concluido: "Concluído",
    entregue: "Entregue",
    cancelado: "Cancelado",
};

export const TIPOS_PREDEFINIDOS = [
    "Revisão",
    "Mudança de Óleo",
    "Travões",
    "Pneus",
    "Corrente / Transmissão",
    "Bateria",
    "Inspeção",
];

// Categorias no formulário do cliente (área do cliente)
export const CATEGORIAS_CLIENTE = ["Revisão Simples", "Revisão Geral", "Outros"];
